export default "__VITE_ASSET__DmRlxpCL__"